// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Nav__navBar___xtCFA","navRight":"Nav__navRight___1QG2J","nav":"Nav__nav___2Dx2Y","navItem":"Nav__navItem___1LtFQ"};


// WEBPACK FOOTER //
// ./webpack:/aws_amplify_ui/src/Nav.css?2528